import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store/index'
import axios from 'axios'
import VueLazyLoad from 'vue-lazyload'
import { createHead } from '@vueuse/head';
import { forceLogoutToLogin } from '@/utils/authSession';
import { installWebAnalytics } from '@/services/webAnalytics';

// GA4 is website-only. installWebAnalytics() is a no-op inside the native
// Capacitor shell, so the iOS app never contacts googletagmanager.com.
installWebAnalytics();

axios.interceptors.response.use(
  response => response,
  error => {
    const url = String(error?.config?.url || '');
    const isCredentialRequest = url.includes('/login') || url.includes('/register');
    if (error.response && error.response.status === 401 && !isCredentialRequest) {
      console.error("Token expired or unauthorized.");
      forceLogoutToLogin();
    }
    return Promise.reject(error);
  }
);


axios.defaults.baseURL =   axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || process.env.VUE_APP_REMOTE_API || "http://localhost:9000/";
const head = createHead();


const app = createApp(App);

// Global Error Handler for Vue components
app.config.errorHandler = (err, instance, info) => {
  console.error("Global Vue Error:", err);
  console.error("Info:", info);

  // Handle specific "User not authenticated" or 401 errors
  if (err.message && (err.message.includes("User not authenticated") || err.message.includes("401"))) {
    forceLogoutToLogin();
  }
};

// Global Handler for non-Vue errors (e.g. unhandled promises)
window.addEventListener('unhandledrejection', event => {
  const reason = event.reason;
  const isAuthError =
    reason === 'User not authenticated' ||
    (reason && reason.message === 'User not authenticated') ||
    (reason && reason?.response?.status === 401);

  if (isAuthError) {
    event.preventDefault();
    return;
  }

  console.error("Unhandled Promise Rejection:", reason);
});

app.use(
  VueLazyLoad, {
    preLoad: 1.3,
    error: require('@/images/coloredfinallogochanged.png'),
    loading: require('@/images/coloredfinallogochanged.png'),
    attempt: 1
  });
  app.use(head);
  
app.use(router);
app.use(store)
app.mount("#app");